'use strict';

var WhatIfRowDetailsDirective = function WhatIfRowDetailsDirective() {
  return {
    restrict: 'E',
    template: require('../templates/what-if-row-details.html'),
    controller: 'WhatIfRowDetailsController',
    scope: {
      detailsData: '='
    }
  };
};
WhatIfRowDetailsDirective.$inject = [];
module.exports = WhatIfRowDetailsDirective;